import { parseNormalizationResponse } from '@updater/ui-widgets';
import { format } from 'date-fns';
import { FormData, Address } from './types';
import { SignupMoverVariables } from 'types/generated/SignupMover';

export const routeMaybeWithQuery = (base: string, query?: string) =>
  query === undefined ? base : `${base}?${query}`;

export const addressForQuery = ({
  normalizationResponse,
  ...address
}: Address) => {
  return {
    ...address,
    ...(normalizationResponse &&
      parseNormalizationResponse(normalizationResponse)),
  };
};

export const formatValues = ({
  movingFromOutsideCountry,
  fromAddress,
  fromOutsideCountryAddress,
  homeSize,
  toAddress,
  ownership,
  moveDate,
  optIn: _optIn, // eslint-disable-line @typescript-eslint/no-unused-vars
  ...otherValues
}: FormData): SignupMoverVariables['input'] => {
  return {
    move: {
      fromAddress:
        movingFromOutsideCountry === 'No'
          ? {
              ...addressForQuery(fromAddress as Address),
              homeSize,
            }
          : {
              city: fromOutsideCountryAddress?.city,
              postalCode: '00000',
              state: '000',
              street: fromOutsideCountryAddress?.street,
              country: fromOutsideCountryAddress?.country,
              unit: fromOutsideCountryAddress?.unit,
            },
      toAddress: {
        ...addressForQuery(
          toAddress ?? {
            street: 'unknown',
            city: 'unknown',
            state: '000',
            postalCode: '00000',
          }
        ),
        ownership,
      },
      moveDate: format(new Date(moveDate), `yyyy-MM-dd'T'HH':'mm':'ss`),
    },
    mover: {
      metadata: {},
      ...otherValues,
    },
    promotions: [],
  };
};
